import React from 'react';
import "./../ThankyouPage.scss";
import { t } from 'i18next';


export function CustomerDetails(props) {  

    const {billingContact, orderType} = props;

    const purchaserEmail = (orderType==="Corporate") ? billingContact?.email : props?.purchaserEmail;
    const purchaserName = props?.purchaserName;
 
    const BuyerDetails = () => {
        return <>
            <div className="details-block">
                <div className="item-container">
                    <div className="item-wrapper">
                        <h4>{t("thankyoupage.yourdetails")}</h4>
                    </div>
                    <div className="item-wrapper">
                    {orderType==="Corporate" ? 
                        <div className="item-field">
                            <p>{billingContact?.name}</p>
                        </div> : ""}
                        <div className="item-field">
                            <p>{purchaserName}</p>
                        </div>
                        <div className="item-field"> 
                            <p>{purchaserEmail}</p> 
                        </div> 
                    </div>
                       
                </div>
            </div>
        </>
           
    }


  
    
    return (<> 
             {BuyerDetails()} 
    
    </>
    )
}